import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../../shared/components';
import { useApi } from '../../../shared/context';
import { QueryKeys } from '../../../shared/hooks';
import { TermSheet } from '../../../shared/models';
import { CerebroApiEndpoints } from '../../../shared/utils/api';
import { getResponseData } from '../../../shared/utils/axios';

interface TermSheetDeleteDialogProps {
	dataRoomGuid: string | undefined;
	sheet: TermSheet | null;
	close: () => void;
}

export const TermSheetDeleteDialog: React.FC<TermSheetDeleteDialogProps> = ({ dataRoomGuid, sheet, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onDeleteConfirmation = () => {
		if (sheet !== null) deleteTermSheet(sheet);
	};

	const { mutate: deleteTermSheet } = useMutation<void, unknown, TermSheet>(
		termSheetToDelete =>
			getResponseData(
				api.delete<void>(CerebroApiEndpoints.TermSheets.Specific(dataRoomGuid, termSheetToDelete.guid))
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.TermSheets.List(dataRoomGuid));
				snackbar.enqueueSnackbar('Term Sheet Deleted.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem deleting the term sheet.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={sheet !== null} onClose={close}>
			<DialogTitle>Confirm Delete Term Sheet</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to delete {sheet?.lenderName} at {sheet?.bankName}?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onDeleteConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
